// used to format UI phone, not for API calls or form input
// DO NOT USE FOR API CALLS OR FORM INPUT

export function formatPhone(phone) {
    if (!phone) return "";
    const digits = phone.replace(/\D/g, "");
    if (digits.length !== 10) return phone;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
